<template>
  <div class="mx-sm-5">
      <component
      :is="currentComponent"
      v-bind="props"
      @activeEditMode="editMode"
      @activeViewMode="enableViewMode"
      @goToCheckList="goToCheckList"
    ></component>
  </div>
</template>

<script>
import CongratsModal from '@/components/Congrats/CongratsModal.vue';
export default {
  components: { CongratsModal },
  props: {
    module: Object,
    parentName: String, 
    childName: String
  },
  data() {
    return {
      viewMode: 1,
      props:{
        moduleOrder: this.module.Order,
        plan: this.module.plan,
        parentName: this.parentName,
        childName: this.childName
      },
      coins: {
        description: '',
        coins: 0,
        points: 0
      },
    };
  },
  computed:{
    currentComponent(){
      if(!this.module.havePlan||this.viewMode==2){
        return () => import('./NewPlan.vue');
      }
      else {
        return () => import('./PlanDetail.vue');
      }
    },
  },
  methods: {
    editMode() {
      this.viewMode = 2
    },
    enableViewMode(plan){
      this.module.havePlan = true
      this.module.plan = plan
      this.viewMode = 1
      this.props = {
        ...this.props,
        moduleOrder: this.module.Order,
        plan: this.module.plan,
      }
    },
    goToCheckList(){
      this.$router.push({name:"checkListId", params: {checkListId:this.module.Order}})
    }
  }
};
</script>
<style lang="scss">
.planningStyle {
  font-size: 1.5rem;
  & > button {
    background-color: white;
  }
}
</style>
